import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath, UserRoles } from "@/enums";

export default {
  namespaced: true,
  state: {
    current_organisation: null
  },
  mutations: {},
  actions: {
    async technologies({}, query) {
      const { data: technologies } = await Get(
        `${ApiPath.Onet}/technologies`,
        {limit: 100, ...query}
      );
      return technologies;
    },
    async jobDescriptionsTest({}, query) {
      const { data: jobDescriptionsTest } = await Get(
        `${ApiPath.Onet}/jobDescriptionsTest`,
        query
      );
      return jobDescriptionsTest;
    },
    async searchCareer({}, keyword) {
      const { data: careers } = await Get(
        `${ApiPath.Onet}/searchcareer?keyword=${keyword}`,
      );
      return careers;
    },
    async searchCareerPassport({}, query) {
      const { data: careers } = await Get(
        `${ApiPath.Onet}/searchcareer`,
        query
      );
      return careers;
    },
    async jobTasks({}, onetCode) {
      const { data: jobTasks } = await Get(
        `${ApiPath.Onet}/jobTasks?onetCode=${onetCode}`
      );
      return jobTasks;
    },
    async getSectorsByCodes({}, { levelOneFilter, levelTwoFilter }) {
      let url = `${ApiPath.Onet}/getsectorsbycodes/`;

      if (levelOneFilter) {
        url += `${levelOneFilter}/`;
        if (levelTwoFilter) {
          url += levelTwoFilter;
        }
      }

      const { data: naics } = await Get(url);
      return naics;
    },
    async workActivities({}, onetCode) {
      const { data: activities } = await Get(
        `${ApiPath.Onet}/workActivities?onetCode=${onetCode}`
      );
      return activities;
    },
    async additionalKnowledge({}, onetCode) {
      const { data: knowledge } = await Get(
        `${ApiPath.Onet}/additionalKnowledge?onetCode=${onetCode}`
      );
      return knowledge;
    },
    async softSkills({}) {
      const { data: softSkills } = await Get(`${ApiPath.Onet}/softSkills`);
      return softSkills;
    },
    async workSkills({}, onetCode) {
      const { data: workSkills } = await Get(
        `${ApiPath.Onet}/workSkills?onetCode=${onetCode}`
      );
      return workSkills;
    },
    async hiddenTalents({}) {
      const { data: hiddenTalents } = await Get(
        `${ApiPath.Onet}/hiddenTalents`
      );
      return hiddenTalents;
    },
    async getsectors({}) {
      const { data: sectors } = await Get(`${ApiPath.Onet}/getsectors`);
      return sectors;
    },
    async hiddenTasks({}, query) {
      const { data: hiddenTasks } = await Get(
        `${ApiPath.Onet}/hiddenTasks`,
        query
      );
      return hiddenTasks;
    }
  }
};
